import axios from 'axios'
import { clearAccessToken } from '../auth/storage'
type JsonRecord = Record<string, unknown>

export class ApiError extends Error {
  status?: number
  details?: unknown
  code?: string

  constructor(message: string, options: { status?: number; details?: unknown; code?: string } = {}) {
    super(message)
    this.name = 'ApiError'
    this.status = options.status
    this.details = options.details
    this.code = options.code
  }
}

function isPlainObject(value: unknown): value is JsonRecord {
  return typeof value === 'object' && value !== null && !Array.isArray(value)
}

function getMessageFromUnknown(value: unknown, fallback: string) {
  if (typeof value === 'string' && value.trim()) {
    return value.trim()
  }

  if (isPlainObject(value)) {
    const candidates = [value.message, value.detail, value.error, value.msg]
    return candidates.map((candidate) => {
      if (typeof candidate === 'string') return candidate.trim()
      if (isPlainObject(candidate) && typeof candidate.message === 'string') return candidate.message.trim()
      return ''
    }).find(Boolean) || fallback
  }

  return fallback
}
export function normalizeAxiosError(error: unknown) {
  if (axios.isAxiosError(error)) {
    const status = error.response?.status
    const payload = error.response?.data

    if (status === 401) {
      clearAccessToken()
    }

    return new ApiError(
      getMessageFromUnknown(
        payload,
        error.message || (status ? `HTTP ${status}` : '请求失败'),
      ),
      {
        status,
        details: payload,
        code: error.code,
      },
    )
  }

  if (error instanceof ApiError) {
    return error
  }

  if (error instanceof Error) {
    return new ApiError(error.message)
  }

  return new ApiError('请求失败')
}
